import Component from '@bythepixel/component-loader';
import LngLat from './lngLat';
import LngLatBounds from './lngLatBounds';
import InfoWindow from './infoWindow';

export default class LocationCard extends Component {
  static selector = '[data-comp-listing-card]'
  static DEFAULTS = {
    onClick: () => {},
    map: undefined,
  };

  #map
  #marker
  #infoWindow
  #locationData = this.$container.dataset
  #latLng = new LngLat(this.#locationData.latitude, this.#locationData.longitude)
  #bounds = new LngLatBounds(this.#locationData.latitude, this.#locationData.longitude);

  constructor(mapEl, options, loaderInstance) {
    super(mapEl, options, loaderInstance);
    this.$setOptions(options, LocationCard.DEFAULTS);
    this.viewMapLink = this.$container.querySelector('[data-view-map-link]');
    this.infoWindowClass = '.mapboxgl-popup';
    this.setMap();
    this.createMarker();
    this.events();
  }

  events() {
    this.viewMapLink.addEventListener('click', (e) => {
      this.$options.onClick();
      this.#map.flyTo(this.#latLng.get().lng, this.#latLng.get().lat);
      this.removeInfoWindows();
      this.createInfoWindow(e);
    });
  }

  createMarker() {
    this.#marker = this.#map.addMarker(this.#locationData);
    this.#latLng = new LngLat(this.#locationData.latitude, this.#locationData.longitude);
    this.#bounds.add(this.#latLng.get());
    this.#marker.on('click', (e) => {
      this.removeInfoWindows();
      this.createInfoWindow(e);
    });
  }

  createInfoWindow(e) {
    this.#infoWindow = new InfoWindow(this.#locationData, this.#map, e);
  }

  removeInfoWindows() {
    this.infoWindows = document.querySelectorAll(this.infoWindowClass);
    this.infoWindows.forEach(infoWindow => {
      infoWindow.remove();
    });
  }

  setMap(map = this.$options.map) {
    this.#map = map;
  }

  getMarker() {
    return this.#marker;
  }
}
